<!--
@Time : 2020/11/26 1:41 下午
@Author : yekong
@File : paiming.vue
@Software : PhpStorm
-->
<template>
  <div>
    <titles title="耗时分析">
      <div class="ztc">
        <zhengti @getactive="getactive"></zhengti>
      </div>
    </titles>
    <div class="paiming2" v-if="active==0">
      <p class="biaoti">
        本市企业开办的平均耗时为2天,评价得分为80分,与第一名上海比较多1天时间,在对标城市中排名
      </p>
      <div class="paimingk">
        <div class="paiming3">
          <div class="head">
            <div class="item1">排名</div>
            <div class="item2">城市</div>
            <div class="item2">耗时</div>
            <div class="item3">得分</div>
          </div>
          <div class="body">
            <div class="bodyitem" v-for="(item,index) in list" :key="index">
              <div class="item1">{{ index + 1 }}</div>
              <div class="item2">{{ item.title }}</div>
              <div class="item2">{{ item.day }}天</div>
              <div class="item3">{{ item.fenshu }}分</div>
            </div>
          </div>
        </div>
        <div class="paiming4">
          <div ref="myChart15" :style="{width: '500px', height: '350px'}"></div>
        </div>
      </div>
    </div>
    <div v-if="active==1">
      <haoshifenxi></haoshifenxi>
    </div>
  </div>
</template>

<script>
import titles from "@/components/title";
import zhengti from "@/components/qiyekaiban/zhengti";
import haoshifenxi from "@/components/qiyekaiban/haoshifenxi";

export default {
  components: {titles, zhengti, haoshifenxi},
  name: "paiming",
  data: function () {
    return {
      active: 0,
      list: [{
        title: '上海',
        fenshu: 90,
        day: 1,
      }, {
        title: '大连',
        fenshu: 80,
        day: 2,
      }, {
        title: '北京',
        fenshu: 80,
        day: 2,
      }, {
        title: '深圳',
        fenshu: 80,
        day: 2
      }]
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  filters: {},
  methods: {
    getactive(e) {
      this.active = e;
      this.$nextTick(function () {
        this.drawLine();
      })
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(this.$refs.myChart15)
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'item'
        },
        series: [{
          type: 'pie',
          center: ['50%', '50%'],
          radius: ['35%', '70%'],
          minAngle: 10,
          avoidLabelOverlap: true,
          roseType: 'radius',
          hoverOffset: 15,
          itemStyle: {
            color: function (params) {
              var colorList = ['#b5ba76', '#4ca698', '#3165e3', '#05a1ef'];
              return colorList[params.dataIndex];
            },
          },
          labelLine: {
            normal: {
              lineStyle: {
                color: 'rgba(114, 189, 255, 1)',
                fontSize: 30
              }
            }
          },
          label: {
            show: true,
            position: 'outer',
            width: 0,
            height: 0,
            fontSize: 30,
            lineHeight: 0,
            backgroundColor: 'auto',
            padding: [2, -2, 2, -2],
            borderRadius: 2,
            distanceToLabelLine: 0,
            formatter: '{top|{b}}',
            align: 'center',

            rich: {
              top: {
                verticalAlign: 'bottom',
                padding: [10, 10, 0, 10],
                align: 'center',
                fontSize: 30,
                color: '#71bdff'
              },
              bottom: {
                padding: [0, 10, 10, 10],
                verticalAlign: 'top',
                align: 'center'
              }
            }
          },
          data: [{
            name: '北京',
            value: 5
          }, {
            name: '上海',
            value: 10
          }, {
            name: '深圳',
            value: 15
          }, {
            name: '大连',
            value: 20
          }]
        }]
      });
    }
  },
  mounted() {
    this.drawLine();
  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.paiming {
  height: 145px;
  @include flex_start_center();
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;

}

.paiming2 {
  .head {
    width: 736px;
    height: 75px;
    margin: auto;
    background: rgba(199, 203, 214, 1);
    @include flex_between_center();

    .item1, .item2, .item3 {
      width: 30%;
      @include flex_center_center();
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #0C1638;
    }

    .item3 {
      width: 40%;
    }
  }
}

.body {
  width: 736px;
  margin: auto;
}

.bodyitem {
  height: 60px;
  @include flex_between_center();
  border-bottom: 2px solid rgba(77, 90, 127, 1);
  box-sizing: border-box;

  .item1, .item2, .item3 {
    width: 30%;
    @include flex_center_center();
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ECEFF9;
  }

  .item3 {
    width: 40%;
  }
}

.biaoti {
  height: 70px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ECEFF9;
  line-height: 36px;
}

.paimingk {
  @include flex_start_start();
}

.paiming4 {
  margin-left: 30px;
  @include flex_center_center();
  width: 630px;
  height: 300px;
}

.ztc {
  padding-top: 20px;
}
</style>
